import {
  FilterTypes,
  StatusFilterType,
  Filter,
  ConversationFilterType,
} from 'apps/chat/constants/LiveChatInterfaces'
import { ChannelType } from 'common/core/constants/ChannelType'
import { FilterCondition, FilterGroupItem, Filter as FilterType } from 'common/filter/interfaces'

export const isFilterStatus = <T extends FilterGroupItem | FilterCondition = FilterGroupItem>(
  filter: FilterTypes,
  value: FilterType<T> | StatusFilterType | null,
): value is StatusFilterType => filter === FilterTypes.STATUS

export const isFilterTagsAndCufs = <T extends FilterGroupItem | FilterCondition = FilterGroupItem>(
  filter: FilterTypes,
  value: FilterType<T> | StatusFilterType | null,
): value is FilterType<T> => filter === FilterTypes.TAGS_AND_CUFS

export const isFilterConversations = (
  filter: Filter,
  value: ConversationFilterType | ChannelType | number | null,
): value is ConversationFilterType => filter === Filter.CONVERSATIONS

export const isFilterTeamMember = (
  filter: Filter,
  value: ConversationFilterType | ChannelType | number | null,
): value is number => filter === Filter.TEAM_MEMBER

export const isFilterChannel = (
  filter: Filter,
  value: ConversationFilterType | ChannelType | number | null,
): value is ChannelType => filter === Filter.CHANNEL

export const isFilterLabel = (filter: Filter, value: number | null): value is number =>
  filter === Filter.LABEL
